import { environment } from '@environment/environment';

const apiBasePath = `${environment.apiBasePath}/services/apexrest/api/v1`;

export const Endpoints = {
  employmentStatus: `${apiBasePath}/utils/empstatus`,
  cno: `${apiBasePath}/utils/cno`,
  cnae: `${apiBasePath}/utils/cnae`,
  countries: `${apiBasePath}/utils/countries`,
  address: `${apiBasePath}/utils/address`,
  products: `${apiBasePath}/utils/products`,
  formdata: `${apiBasePath}/utils/formData`,
  impositionCondition: `${apiBasePath}/utils/impositioncondition`
};
